import { GET_TIME_SLOTS } from "../actions/types";

const initialState = {
  timeSlots: [],
  loading: true,
};

const serviceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TIME_SLOTS:
      return {
        ...state,
        timeSlots: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default serviceReducer;
